import type { ReactNode } from 'react';

export const symbol_signal_cellular_connected_no_internet_0_bar: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m131-131 698-698q14-14 32.5-6.5T880-808v123q0 13-8.5 21.5T850-655q-13 0-21.5-8.5T820-685v-50L224-140h486q13 0 21.5 8.5T740-110q0 13-8.5 21.5T710-80H152q-20 0-27.5-18.5T131-131Zm698 42q-9-9-9-21t9-21q9-9 21-9t21 9q9 9 9 21t-9 21q-9 9-21 9t-21-9Zm-9-141v-315q0-13 8.5-21.5T850-575q13 0 21.5 8.5T880-545v315q0 13-8.5 21.5T850-200q-13 0-21.5-8.5T820-230Z"
		/>
	</svg>
);
